/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'upload-new': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<defs><clipPath id="clip-path"><path pid="0" class="cls-1" d="M-7-360h-8v-2h6v-14h-18v14h6v2h-8v-18h22zm-11-13l4 4h-3v9h-2v-9h-3zm9 13h-6v-2h6v-14h-18v14h6v2h-6a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zm-9-13l4 4h-3v9h-2v-9h-3z"/></clipPath></defs><g id="系统图标"><g id="账号管理中心"><path pid="1" id="icon_action_system_vertical_alt_24px" data-name="icon/action/system_vertical_alt_24px" class="cls-3" d="M12 8l4 4h-3v9h-2v-9H8zm9 13h-6v-2h6V5H3v14h6v2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zM12 8l4 4h-3v9h-2v-9H8zm11 13h-8v-2h6V5H3v14h6v2H1V3h22z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/upload-new.js